export const CHART_BASE_DIMENSION = 'revenue_dt' as const;
